import { render, staticRenderFns } from "./busesBus.vue?vue&type=template&id=e5c71122&scoped=true&"
import script from "./busesBus.vue?vue&type=script&lang=js&"
export * from "./busesBus.vue?vue&type=script&lang=js&"
import style0 from "./busesBus.vue?vue&type=style&index=0&id=e5c71122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c71122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VForm,VSelect,VTextField})
